import Subheading from 'components/Subheading';
import GreenPageSection from 'components/GreenPageSection';
import RoundedButton from 'components/RoundedButton';
import HowItWorksSteps from 'components/common/HowItWorksSteps';

const HowItWorksSection = ({ onCtaClick }) => {
  return (
    <GreenPageSection>
      <Subheading>
        How It <strong>Works</strong>
      </Subheading>

      <HowItWorksSteps />

      <RoundedButton onClick={onCtaClick} style={{ width: 280, margin: '2em 0 0' }}>
        Enter Now
      </RoundedButton>
    </GreenPageSection>
  );
};

export default HowItWorksSection;
